import React from "react";
import PropTypes from "prop-types";
import ModalWrapper from "./ModalWrapper";
import CustomTimerange from "./CustomTimerange";

const DatePickerModal = ({ show, onClose, onApply }) => (
  <ModalWrapper
    id="date-picker-modal"
    show={show}
    title="Select Time Range"
    size="sm"
    onHide={() => onClose(false)}
    className="rdt__menu-container rdt__menu-container--inline no-overflow"
  >
    <CustomTimerange
      autoFocus
      onApply={timerange => {
        onClose(false);
        onApply(timerange);
      }}
      className="flex flex-column"
    />
  </ModalWrapper>
);

DatePickerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onApply: PropTypes.func,
  onClose: PropTypes.func.isRequired
};

export default DatePickerModal;
